export enum CampusSubject {
  MATHE = 'Mathematik',
  DEUTSCH = 'Deutsch',
  ENGLISCH = 'Englisch',
  FRANZÖSISCH = 'Französisch',
  BIOLOGIE = 'Biologie',
  CHEMIE = 'Chemie',
  Physik = 'Physik',
  NAWI = 'Naturwissenschaften',
  SPANISCH = 'Spanisch',
  LATEIN = 'Latein',
  GESCHICHTE = 'Geschichte',
  DEUTSCHZWEITSPRACHE = 'Deutsch als Zweitsprache',
  CHANCENKURVE = 'CHANCENkurve',
  POLITIK = 'Politik',
}

export const availableCampusSubjects = [
  CampusSubject.CHANCENKURVE,
  CampusSubject.MATHE,
  CampusSubject.DEUTSCH,
  CampusSubject.ENGLISCH,
  CampusSubject.BIOLOGIE,
  CampusSubject.CHEMIE,
  CampusSubject.POLITIK,
];
